(function () {
  "use strict";

  let loadPromise = null;

  window.loadFlickity = function loadFlickity() {
    if (typeof Flickity !== "undefined") {
      return Promise.resolve();
    }

    if (loadPromise) {
      return loadPromise;
    }

    const assets = window.__flickityAssets;
    if (!assets || !assets.css || !assets.js) {
      return Promise.reject(new Error("Flickity assets are not configured"));
    }

    loadPromise = new Promise((resolve, reject) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = assets.css;
      link.media = "print";
      link.onload = () => {
        link.media = "all";
      };
      document.head.appendChild(link);

      const script = document.createElement("script");
      script.src = assets.js;
      script.onload = () => resolve();
      script.onerror = () => {
        loadPromise = null;
        reject(new Error("Failed to load Flickity"));
      };
      document.head.appendChild(script);
    });

    return loadPromise;
  };
})();
